import React from "react";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_deploy-base44/artifacts/4oqn0emj_Dr.%20Mark%20Sullivan%20Message%20Promo%20%28Take%201%20%29.mp4";

const POSTER_URL = "/images/sullivan-poster.jpg";

export default function SuperintendentVideo() {
  return (
    <section
      className="mb-6 bg-card rounded-xl border border-border p-4"
      data-testid="superintendent-video"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        <div className="flex-1 min-w-0">
          <p
            className="text-xl md:text-2xl font-semibold leading-tight"
            style={{ color: "#541011" }}
          >
            Superintendent Dr. Mark Sullivan Invites You to the Future of
            Teaching with AI
          </p>
        </div>
        <div className="w-full md:w-1/2 flex-shrink-0">
          <video
            src={VIDEO_URL}
            poster={POSTER_URL}
            controls
            playsInline
            preload="none"
            className="w-full rounded-lg shadow bg-black"
            data-testid="superintendent-video-player"
          />
        </div>
      </div>
    </section>
  );
}
